import { isArray } from 'util';
import { Source } from '../source';

export class SourceBuilder {
  static fromJson(json) {
    return (json)
      ? new Source(
        json.hash,
        json.name,
        json.active
      )
      : null;
  }

  static fromList(list) {
    return (isArray(list)) ? list.map(SourceBuilder.fromJson) : [];
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/source.builder.ts